export const DEFAULT_NOTE_COUNT = 8
